module.exports = __webpack_public_path__ + "static/media/transfer_a_person.f4397f2a.svg";